// extracted by mini-css-extract-plugin
export default {"partner-slide":"Home_partner-slide__4UXfB","arrow-btn":"Home_arrow-btn__pkcTk"};